export enum PriceRateAdjustmentType {
  Percentage = "Percentage",
  Amount = "Amount",
}
